import { initSection } from '../../core/shopify/init-section/index.js';
import { formatMoney } from '../../core/shopify/format-money.js';
import { dispatchWishlistVariantChanged } from '../../product/wishlist-button.js';
import { openRestockModal } from '../../product/stoq.js';
import { addVariantToCart, getVariantById } from './add-variant-to-cart.js';
import { initMobileBar } from './mobile-bar.js';
import { initVariantDropdown } from './variant-dropdown.js';
const NAMESPACE = '.js-gift-sets-pdp-details-section';
initSection(NAMESPACE, (section)=>{
    const bar = section.querySelector('.js-gift-sets-pdp-details-bar');
    const addToCartButton = section.querySelector('.js-gift-sets-pdp-details-add-to-cart');
    const priceEl = section.querySelector('.js-gift-sets-pdp-details-price');
    const unloadMobileBar = initMobileBar(section);
    if (!bar || !addToCartButton || !priceEl) {
        return {
            unload: ()=>{
                unloadMobileBar();
            }
        };
    }
    const productJson = bar.dataset.productJson;
    const moneyFormat = bar.dataset.moneyFormat ? JSON.parse(bar.dataset.moneyFormat) : '${{amount}}';
    const product = productJson ? JSON.parse(productJson) : null;
    /*
   * A sold out size is still selectable; the button becomes the notify
   * control instead of add to cart, so the choice is visible before the
   * Restock Rocket modal opens.
   */ let isNotifyMode = false;
    /*
   * Set when add to cart opens the dropdown because no size was chosen yet:
   * picking an available size then adds it straight away. Cleared whenever
   * the dropdown closes, so opening it from its own trigger only selects.
   */ let addOnSelect = false;
    const addToCart = async (variant)=>{
        if (!product) return;
        addToCartButton.disabled = true;
        try {
            await addVariantToCart(product, variant);
        } catch (err) {
            console.error('[gift-sets-pdp-details] add to cart failed', err);
        } finally{
            addToCartButton.disabled = false;
        }
    };
    const dropdown = initVariantDropdown(section, {
        onSelect: (variantId)=>{
            if (!product) return;
            const variant = getVariantById(product, variantId);
            if (!variant) return;
            isNotifyMode = !variant.available;
            addToCartButton.classList.toggle('is-notify', isNotifyMode);
            addToCartButton.dataset.variantId = String(variant.id);
            addToCartButton.disabled = false;
            if (!isNotifyMode) {
                priceEl.textContent = formatMoney(variant.price, moneyFormat);
            }
            dispatchWishlistVariantChanged({
                product,
                selectedVariant: variant,
                firstOptionWithoutSelectedValue: null,
                isSelectedVariantAvailable: variant.available
            });
            if (addOnSelect && variant.available) {
                void addToCart(variant);
            }
        },
        onClose: ()=>{
            addOnSelect = false;
        }
    });
    /*
   * Publishes the initial "nothing selected" state, so the wishlist button
   * prompts for a size instead of silently using the default variant. The
   * wishlist module binds its listener synchronously from the product bundle,
   * which `initSection` always defers past.
   */ if (dropdown && product) {
        delete addToCartButton.dataset.variantId;
        dispatchWishlistVariantChanged({
            product,
            selectedVariant: null,
            firstOptionWithoutSelectedValue: dropdown.optionName(),
            isSelectedVariantAvailable: null
        });
    }
    addToCartButton.addEventListener('click', async ()=>{
        if (!product || addToCartButton.disabled) return;
        /*
     * The button keeps its enabled styling with no size chosen, per the
     * design, so it opens the size dropdown rather than adding an arbitrary
     * variant.
     */ if (dropdown && dropdown.selectedVariantId() === null) {
            dropdown.open();
            addOnSelect = true;
            dropdown.focus();
            return;
        }
        const variantId = Number(addToCartButton.dataset.variantId);
        const variant = getVariantById(product, variantId);
        if (!variant) return;
        // The chosen size is sold out, so the button offers the notify flow.
        if (isNotifyMode) {
            openRestockModal(product, variantId);
            return;
        }
        await addToCart(variant);
    });
    return {
        unload: ()=>{
            unloadMobileBar();
            dropdown === null || dropdown === void 0 ? void 0 : dropdown.cleanup();
        }
    };
});
